import Actions from './form-actions';
import Api from './form-api';
import Collection from './form-collection';
import Model from './form-model';
import reducer from './form-reducer';
import Selectors from './form-selectors';
import sagas from './form-sagas';

export default {
  Actions,
  Api,
  Collection,
  Model,
  namespace: 'form',
  reducer,
  sagas:     [sagas],
  Selectors,
};
